import React from 'react';
import './pillarcard.css';

const Header = () => {
  return (
    <> 
    <nav className="navbar">
      <ul className="navbar-menu">
        <li className="navbar-item">
          <a href="#home">Home</a>
        </li>
        <li className="navbar-item">
          <a href="#about">About Dev</a>
        </li>
        <li className="navbar-item">
          <a href="#projects">Projects</a>
        </li>
        <li className="navbar-item">
          <a href="#tools">Tools</a>
        </li>
        <li className="navbar-item">
          <a href="#contact">Contact</a>
        </li>
      </ul>
    </nav>
    </>
  );
};

export default Header;